// import * as Yup from 'yup';
import React, { useState, useEffect } from 'react';
import {
   Dialog,
   styled,
   Typography,
   MenuItem,
   Select,
   FormControl,
   TextField,
   IconButton,
   InputAdornment,
   Button,
   Box,
   InputLabel,
   // Link,
} from '@mui/material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
// import ErrorSharpIcon from '@mui/icons-material/ErrorSharp';
import { useNavigate } from 'react-router-dom';
// import { Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { getTransactions } from '../../utils/selectors/selectors';
import {
   amountPayable,
   getAmountConv,
   getUnitsConv,
} from '../../app/features/transactions/TransactionSlice';
import { debounce } from 'lodash';
import { FaTimes } from 'react-icons/fa';
import { toast } from 'react-toastify';
import spinner from '../../../assets/spinner.svg';

const DialogWrapper = styled(Dialog)(
   () => `
        .MuiDialog-paper {
          overflow: visible;
        }
     
  `
);

const TextInput = styled(TextField)(
   ({ theme }) => `
	margin-top:5px;
         background: white;
         color: #49454F;
           font-family: 'Raleway', 'Montserrat', sans-serif;
         &.placeholer{
          color: red;
         }
       `
);

const TopUpForm = ({ openForm, closeForm }) => {
   const [topUpMenu, setTopUpMenu] = useState('Amount');
   const [amount, setAmount] = useState('');
   const [units, setUnits] = useState('');
   const [enabled, setEnabled] = useState('');
   const [loading, setLoading] = useState(false);
   const [currency, setCurrency] = useState('₦');

   useEffect(() => {
      const user = JSON.parse(localStorage.getItem('userAuth'));
      const currency = user?.country != 'Nigeria' ? '$' : '₦';
      setCurrency(currency);
   }, []);

   const selector = useSelector(getTransactions);
   const dispatch = useDispatch();

   const handleSelect = (event) => {
      setTopUpMenu(event.target.value);
   };

   const getUnits = debounce((value) => {
      setLoading(true); // Start loading
      dispatch(getAmountConv({ event: value })).finally(() =>
         setLoading(false)
      ); // Stop loading after fetch
   }, 500);

   const getAmount = debounce((value) => {
      setLoading(true); // Start loading
      dispatch(getUnitsConv({ event: value })).finally(() => setLoading(false)); // Stop loading after fetch
   }, 500);

   const navigate = useNavigate();

   const handleChange = (event) => {
      const value = event.target.value.toString();
      if (topUpMenu === 'Amount') {
         setAmount(value);
         getUnits(value);
      } else {
         setUnits(value);
         getAmount(value);
      }
   };

   const handleSubmit = (event) => {
      event.preventDefault();
      const total =
         topUpMenu === 'Amount'
            ? { amount: amount }
            : { amount: selector.amountConv.toString() };

      if (currency === '₦' && Number(total.amount) < 1000) {
         toast.error('The minimum top up is ₦1000');
         return;
      }

      if (currency === '$' && Number(total.amount) < 10) {
         toast.error('The minimum top up is $10');
         return;
      }

      dispatch(amountPayable(total));
      navigate('/top-up/payment');
   };

   const check = (e) => setEnabled(e.target.value);

   return (
      <div>
         <DialogWrapper
            open={openForm}
            maxWidth="sm"
            fullWidth
            onClose={closeForm}
         >
            <Box
               sx={{
                  mt: 2,
                  position: 'relative',
                  mx: '18px',
               }}
            >
               <Box
                  sx={{
                     height: '5px',
                     width: '100px',
                     borderRadius: '5px',
                     mx: 'auto',
                     bgcolor: '#0040BF',
                  }}
               ></Box>
               <FaTimes
                  size={20}
                  style={{
                     position: 'absolute',
                     right: 0,
                     top: 0,
                     cursor: 'pointer',
                     color:'#0040BF'
                  }}
                  onClick={() => closeForm()}
               />
            </Box>
            <Typography
               color="#0F0E0E"
               fontSize={18}
               fontWeight={600}
               align="center"
               mt={3}
               sx={{
                   fontSize:{xs:'1.4rem', sm:'2.3rem'}
               }}
                className="font-cormorant"
            >
               Buy SMS Unit
            </Typography>

            <Typography
               align="center"
               fontSize={16}
               color="#58564d"
               mb={2}
              
            >
               How much would you like to fund your account with?
            </Typography>
            <FormControl
               style={{
                  width: '100%',
                  maxWidth: '150px',
                  border: 'none',
                  marginLeft: '20px',
                  marginTop: '10px',
                 
               }}
            >
               <Select
                  sx={{
                     mb: '1rem',
                    
                     
                  }}
                  value={topUpMenu}
                  onChange={handleSelect}
                  displayEmpty
                  
               >
                  <MenuItem
                     value="Amount"
                     sx={{
                        
                     }}
                  >
                     <Typography
                        fontSize={15}
                        sx={{
                         
                        }}
                     >
                        Enter Amount
                     </Typography>
                  </MenuItem>
                  <MenuItem
                     value="SMS Unit"
                     sx={{
                    
                     }}
                  >
                     <Typography
                        fontSize={15}
                        sx={{
                        
                        }}
                     >
                        Enter SMS Unit
                     </Typography>
                  </MenuItem>
               </Select>
            </FormControl>

            <form onSubmit={handleSubmit}>
               <Box mb={4} display="flex" flexDirection="column" px={2}>
                  <InputLabel
                     align="left"
                     htmlFor="val"
                     margin="dense"
                     sx={{
                        color:'#2E2C21',
                        fontSize:{xs:'1rem', sm:'1.2rem'},
                        fontWeight:400
                     }}
                  >
                     {topUpMenu === 'Amount'
                        ? `${topUpMenu} ${currency}`
                        : topUpMenu}
                  </InputLabel>
                  <TextInput
                     id="val"
                     fullWidth
                     margin="normal"
                     name={topUpMenu}
                     
                     // onBlur={handleBlur}
                     onChange={handleChange}
                     type="number"
                     value={topUpMenu === 'Amount' ? amount : units}
                     variant="outlined"
                     InputProps={{
                        sx: {
                    
                           mb: 2,
                        },
                        endAdornment: (
                           <InputAdornment position="end">
                              <IconButton
                                 edge="end"
                                 onClick={() => {
                                    setAmount('');
                                    setUnits('');
                                 }}
                              >
                                 <HighlightOffIcon />
                              </IconButton>
                           </InputAdornment>
                        ),
                     }}
                  />
                  <InputLabel
                     align="left"
                     htmlFor="trans"
                     margin="dense"
                     sx={{
                        display: 'flex',
                        columnGap: '8px',
                        alignItems: 'center',
                        color:'#2E2C21',
                        fontSize:{xs:'1rem', sm:'1.2rem'},
                        fontWeight:400
                     }}
                  >
                     {topUpMenu === 'SMS Unit'
                        ? `Amount ${currency}`
                        : 'SMS Units'}{' '}
                     {loading && (
                        <img
                           src={spinner}
                           style={{ width: '25px' }}
                           alt="loading"
                        />
                     )}
                  </InputLabel>
                  <TextInput
                     fullWidth
                     margin="dense"
                     id="trans"
                     name="result"
                     // onBlur={handleBlur}
                     onChange={check}
                     type="text"
                     value={
                        topUpMenu === 'Amount' && amount !== ''
                           ? selector.unitsConv
                           : topUpMenu === 'SMS Unit' && units !== ''
                           ? selector.amountConv
                           : '0'
                     }
                     variant="outlined"
                     disabled
                  />

                  <Button
                     disabled={units === '' && amount === ''}
                     sx={{
                        borderRadius: '11px',
                        py: '10px',
                        // px: '35px',
                        fontSize: '15px',
                        width: '50%',
                        mx: 'auto',
                        mt: '40px',

                        
                     }}
                     variant="contained"
                     size="small"
                     type="submit"
                  >
                     Confirm
                  </Button>
                  <br />
               </Box>
            </form>
         </DialogWrapper>
      </div>
   );
};

export default TopUpForm;
